import React, {Fragment, useEffect, useState} from "react";
import {MachineContacts} from "./MachineContacts";
import {ConfirmationPrompt} from "../../../ui/ConfirmationPrompt";
import {useTranslation} from "react-i18next";
import {removeContacts} from "../../../../api/machine-functions";
import {useApiNotification} from "../../../ui/ApiNotificationProvider";
import {GreyedOutProgressMask} from "../../../ui/GreyedOutProgressMask";
import {run} from "../../../../utils/function-util";

export const MachineContactList = (props: any) => {
    const {t} = useTranslation();
    const {handleError} = useApiNotification();
    const [userToDelete, setUserToDelete] = useState<any>();
    const [disableDelete, setDisableDelete] = useState(false);
    const [refresh, setRefresh] = useState(0);
    const {userId} = props;

    const removeContact = (contactUserId: any) => {
        setUserToDelete(contactUserId);
    };

    const deleteContact = async () => {
        setDisableDelete(true);
    };

    useEffect(run(async () => {
            if (disableDelete) {
                const user = [userToDelete];
                setUserToDelete(null);
                return await removeContacts(userId, user);
            }
        },
        (success: any) => {
            if (disableDelete) {
                if (success) {
                    setRefresh(r => r + 1);
                } else {
                    const err = {response: {data: {error: {type: 'FailedToRemoveContact'}}}};
                    handleError(err);
                }
            }
        },
        handleError,
        () => setDisableDelete(false)
    ), [disableDelete]);

    return (
        <Fragment>
            <GreyedOutProgressMask isActive={disableDelete} displaySpinner={true}>
                <MachineContacts onRemoveContact={removeContact} refresh={refresh} {...props}/>
                <ConfirmationPrompt
                    title={t(`Machine.Contacts.Remove.Title`)}
                    description={t('Machine.Contacts.Remove.Description')}
                    open={!!userToDelete}
                    disable={disableDelete}
                    onCancel={() => setUserToDelete(undefined)}
                    onConfirm={() => deleteContact()}
                />
            </GreyedOutProgressMask>
        </Fragment>)
};
